/*
 * @Author: zenghao
 * @Date: 2022-05-05 10:53:11
 * @LastEditors: zenghao
 * @LastEditTime: 2022-05-05 11:02:21
 * @Description: 请填写简介
 */
import { useState } from 'react'
import { Options } from '../types'

const useSearch = (options: Options) => {
  const [searchValue, setSearchValue] = useState('')

  const handleSearchValueChange = (searchValue) => {
    setSearchValue(searchValue)
  }

  const searchValueEscape = (searchValue) => {
    const specialCharacter = ['\\', '$', '(', ')', '*', '+', '.', '[', '?', '^', '{', '|']
    specialCharacter.forEach(str => {
       const reg = new RegExp('\\' + str, 'gim')
       searchValue = searchValue?.replace?.(reg, '\\' + str)
     })

     return searchValue
  }

  const replaceMatch = (text, _searchValue = searchValue) => {
    _searchValue = searchValueEscape(_searchValue)
    const reg = new RegExp(`${_searchValue}`, 'gi')
    const setText = (text) => `<span style='color: #006EFF'>${text}</span>`
    return text?.replace?.(reg, (matchText) => setText(matchText))
  }

  const buildHighLightData: () => Options = () => {
    // 无 searchValue 展示全部
    if (!searchValue) return options

    const renderOptions = options?.map(option => {
      // const filterText = option?.text?.replace(reg, (matchText) => setText(matchText))
      const filterText = replaceMatch(option?.text)

      // 过滤掉不包含 searchValue 的项
      if (option.text === filterText) return null

      return {
        ...option,
        text: filterText
      }
    })
    return renderOptions?.filter(item => item !== null) as Options
  }

  return {
    searchValue,
    replaceMatch,
    buildHighLightData,
    handleSearchValueChange
  }
}

export default useSearch